import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import I18n from 'lib/i18n/i18n';
import {
    isMobile,
    chatBotKind,
    versionOfHvCui,
} from 'helpers/ApplicationHelper';
import {scheduleAppointment} from 'actions/user';
import {autoEstimateForCUI, highValueSaveLog, hvCuiSaveLog} from 'actions/item';
import ItemChatBot from 'components/chatBot/itemChatBot';
import BaseChatBot from "../../chatBot/baseChatBot";

class HighValueEstimation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            busyTimes: this.props.ADO.high_value_busy_times,
            timeSlotOptions: {}
        };
    };

    componentDidMount() {
        this.props.hvCuiSaveLog(this.props.Item.id, this.props.hvCuiVersion,
            I18n.getString('itemPage::highValueEstimation::1::events::messages::hvCuiPresented'), this.props.Item.hvCuiLastMessageKey, 'hv_cui_page_presented');
    };

    componentWillUnmount() {
        // FIXME: remove DOM manipulation fromoutside the app
        let sellItemWizard = document.querySelector('.sell-item-wizard')
        if (sellItemWizard) {sellItemWizard.removeAttribute('style');}
        let header = document.querySelector('header')
        if (header) {header.removeAttribute('style');}
    }

    render() {
            const mobile = isMobile();
        return (
            <div>
                <div id="item-state-high-value-estimation" >
                    <div id="item-state-high-value-estimation-vip-explanation-texts" className="black-stripe black-stripe-cui">
                        <div className="bell-img"></div>
                        <div id="item-state-high-value-estimation-worthy-vip" className="vip-container">
                            {
                                mobile ? (
                                    <div>
                                        <h1>{I18n.getString('itemPage::highValueEstimation::1::vip::worthyVIP')}</h1>
                                        <div className="text">
                                            <div>{I18n.getString('itemPage::highValueEstimation::1::vip::mobileText::line1')}</div>
                                            <div>{I18n.getString('itemPage::highValueEstimation::1::vip::mobileText::line2')}</div>
                                        </div>
                                    </div>
                                ) : (
                                    <div>
                                        <h1>{I18n.getString('itemPage::highValueEstimation::1::vip::worthyVIP')}</h1>
                                        <div>
                                            <div className="vip-col">
                                                <div
                                                    className="title">{I18n.getString('itemPage::highValueEstimation::1::vip::singlePointOfContact::title')}</div>
                                                <div
                                                    className="text">{I18n.getString('itemPage::highValueEstimation::1::vip::singlePointOfContact::text')}</div>
                                            </div>
                                            <div className="vip-col vip-col-right">
                                                <div
                                                    className="title">{I18n.getString('itemPage::highValueEstimation::1::vip::insuredNextDayPickup::title')}</div>
                                                <div
                                                    className="text">{I18n.getString('itemPage::highValueEstimation::1::vip::insuredNextDayPickup::text')}</div>
                                            </div>
                                            <div className="vip-col">
                                                <div
                                                    className="title">{I18n.getString('itemPage::highValueEstimation::1::vip::personalHandling::title')}</div>
                                                <div
                                                    className="text">{I18n.getString('itemPage::highValueEstimation::1::vip::personalHandling::text')}</div>
                                            </div>
                                            <div className="vip-col vip-col-right">
                                                <div
                                                    className="title">{I18n.getString('itemPage::highValueEstimation::1::vip::strategicConsulting::title')}</div>
                                                <div
                                                    className="text">{I18n.getString('itemPage::highValueEstimation::1::vip::strategicConsulting::text')}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div id="item-state-estimation-ready">
                    <div className="item-state-estimation-ready-container black-chat-bot">
                        <ItemChatBot highValueCUI={true}
                                     options={this.state.timeSlotOptions}
                                     acceptEstimation={this.props.acceptEstimation}
                                     generateShippingLabel={this.props.generateShippingLabel}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        ADO,
        Item,
        ChatBot,
        Personalized
    } = state;
    // TODO: should be unified in one place or work via Store
    const hvCuiVersion = versionOfHvCui(Personalized, ChatBot)
    return Object.assign(BaseChatBot.mapStateToPropsObject(state, chatBotKind(Item, ADO.user)), {
        Item,
        hvCuiVersion,
    });
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({scheduleAppointment, highValueSaveLog, autoEstimateForCUI, hvCuiSaveLog}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(HighValueEstimation);
